import { Service } from "@/interfaces/roles";
import { AuthState, User } from "@/vuex/auth/types";
import { MutationTree } from "vuex";

type AuthMutationTree = MutationTree<AuthState>;

export const mutations: AuthMutationTree = {
  setUser(state: AuthState, user: User) {
    state.user = user;
    state.isLogged = true;
  },
  unsetUser(state: AuthState) {
    state.user = null;
    state.isLogged = false;
  },
  setServices(state: AuthState, payload: Service[]) {
    state.acountServices = payload;
  },
  setAccessToken(state: AuthState, token: string) {
    state.accessToken = token;
  },
  setRedirect(state: AuthState, url: string) {
    state.redirectTo = url;
  },
  setUserPermissions(state: AuthState, permissions: any[] | null) {
    state.userPermissions = permissions;
  },
  setLoading(state: AuthState, loading: boolean) {
    state.loading = loading;
  },
  setAppId(state: AuthState, id: string) {
    state.appId = id;
  }
};
